export default __webpack_public_path__ + "static/media/bestseller1.7b238122.png";